/** @flow */
import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import { translate } from 'react-i18next';
import _ from 'lodash';

import CommercialAgeGroup from 'common/components/charts/CommercialAgeGroup';
import { Percent, displayPercent } from 'common/components/Number';
import SCard from 'common/components/cards/SCard';
import AgeRangeGraph from 'common/components/charts/AgeRangeGraph';

const CardWrapper = styled.div`
  padding-top: 0;
  padding: ${({ theme }) => theme.metrics.margin}px;
  display: flex;
  flex-direction: column;

  margin-bottom: ${({ theme }) => theme.metrics.margin}px;
`;

const CardContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const GraphWrapper = styled.div`
  flex: ${({ flex }) => flex};
  width: 0;
  height: 288px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const GraphContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const GenderWrapper = styled.div`
  text-align: center;
`;

const GenderText = styled.div`
  font-size: 1.1rem;
  color: ${({ theme, gender }) => theme.colors[gender]};
  width: 100%;
`;

type Props = {
  genderDemography: ?Object;
  ageGroup: ?Object;
  t: any,
  theme: any,
};

class DemographyGraph extends React.Component<Props> {
  shouldComponentUpdate(nextProps: Props): boolean {
    return !_.isEqual(this.props, nextProps);
  }

  render() {
    const { genderDemography, ageGroup, t } = this.props;

    if (!genderDemography && !ageGroup) {
      return null;
    }

    return (
      <SCard title={t('demography')}>
        <CardWrapper>
          <CardContent>
            {this.renderGenderDemography(genderDemography)}
            {this.renderAgeGroup(ageGroup)}
          </CardContent>
        </CardWrapper>
      </SCard>
    );
  }

  renderGenderDemography(genderDemography: ?Object) {
    if (!genderDemography) {
      return null;
    }

    const { t, theme } = this.props;

    const total = genderDemography.male + genderDemography.female;
    const malePercent = genderDemography.male / total;
    const femalePercent = genderDemography.female / total;
    const genderData = [
      { name: t('gender.men'), value: malePercent, color: 'male' },
      { name: t('gender.women'), value: femalePercent, color: 'female' },
    ];

    return (
      <GraphWrapper flex={1}>
        <ResponsiveContainer height={240} width="100%">
          <PieChart>
            <Pie data={genderData} dataKey="value">
              {genderData.map(entry => <Cell key={entry.name} fill={theme.colors[entry.color]} />)}
            </Pie>
            <Tooltip formatter={label => displayPercent(label)} />
          </PieChart>
        </ResponsiveContainer>
        <GenderWrapper>
          <GenderText gender="male">{t('gender.men')} <Percent value={malePercent} /></GenderText>
          <GenderText gender="female">{t('gender.women')} <Percent value={femalePercent} /></GenderText>
        </GenderWrapper>
      </GraphWrapper>
    );
  }

  renderAgeGroup(ageGroup: ?Object) {
    if (!ageGroup) {
      return null;
    }

    return (
      <GraphWrapper flex={2}>
        <CommercialAgeGroup ageGroup={ageGroup} direction="horizontal" />
        <GraphContent>
          <AgeRangeGraph height={220} data={ageGroup} hideCommercialAgeGroup />
        </GraphContent>
      </GraphWrapper>
    );
  }
}

export default translate()(withTheme(DemographyGraph));



// WEBPACK FOOTER //
// ./src/common/modules/sales/components/DemographyGraph.js